import { NavLink } from 'react-router-dom';
import CartWidget from '../Cart/CartWidget';

export default function MainMenu() {
  return (
    <nav className="nav">
      <NavLink to="/" end className="nav-link">Home</NavLink>
      <NavLink to="/how-it-works" className="nav-link">How It Works</NavLink>
      <NavLink to="/shop" className="nav-link">Shop</NavLink>
      <NavLink to="/admin-inventory" className="nav-link">Admin</NavLink>
      <CartWidget/>
    </nav>
  );
}